var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mobile-occupation", style: _vm.cssVars }, [
    _c("div", { staticClass: "mobile-section-title" }, [
      _c("span", [_vm._v("您从事什么职业？")]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "mobile-section-title__more",
          on: { click: _vm.goMore },
        },
        [_vm._v("更多")]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mobile-occupation__scroll" },
      _vm._l(_vm.occupationGroups, function (group, gi) {
        return _c(
          "div",
          { key: gi, staticClass: "mobile-occupation__page" },
          _vm._l(group, function (item, index) {
            return _c(
              "div",
              {
                key: item.id || gi * 2 + index,
                staticClass: "mobile-occupation__item",
                style: {
                  backgroundImage: "url(" + _vm.getJobBg(gi * 4 + index) + ")",
                },
                on: {
                  click: function ($event) {
                    return _vm.handleClick(item)
                  },
                },
              },
              [
                _c("div", { staticClass: "mobile-occupation__overlay" }),
                _vm._v(" "),
                _c("span", { staticClass: "mobile-occupation__name" }, [
                  _vm._v(_vm._s(item.name)),
                ]),
              ]
            )
          }),
          0
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }